export function createError(k, args) {
  return {
    key: k,
    args: args ? { ...args } : null
  };
}

export default createError;
